export default "__VITE_ASSET__13368cab__"